const MONTHS = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"];
const cls = "h-8 px-2 rounded-lg border border-slate-200 text-xs bg-white";

export default function PeriodFilter({ years = [], year, month, onChange }) {
  const ys = years.length ? years : [String(new Date().getFullYear())];
  return <>
    <select value={year} onChange={e => onChange({ year: e.target.value, month: e.target.value ? month : "" })} className={cls} data-testid="dh-year"><option value="">Toutes les années</option>{ys.map(y => <option key={y} value={y}>{y}</option>)}</select>
    <select value={month} disabled={!year} onChange={e => onChange({ year, month: e.target.value })} className={`${cls} disabled:opacity-50`} data-testid="dh-month"><option value="">Tous les mois</option>{MONTHS.map((m, i) => <option key={m} value={i + 1}>{m}</option>)}</select>
  </>;
}
